<div class="a-dialog-container" [style.width]="config.width" [style.maxWidth]="config.maxWidth||''"
    [style.minWidth]="config.minWidth||''">
    <div class="a-dialog-header">
        <span class="a-dialog-header-title tell">{{config.title}}</span>
        <span class="a-dialog-action-container" *ngIf="config.canClose">
            <span class="a-dialog-action-close" (click)="closeDialog()"><i class="fa fa-times"></i></span>
        </span>
    </div>
    <div class="a-dialog-content">
        <ng-container *ngIf="config.templateRef">
            <div *ngTemplateOutlet="config.templateRef;context:{data:templateRefContext};"></div>
        </ng-container>
    </div>
    <div class="a-dialog-footer">
        <ad-button (onClick)="closeDialog()" [styleClass]="{'btn-secondary':true}" *ngIf="config.noVisible === true">{{config.confirmNoText}}</ad-button>
        <ad-button (onClick)="yesDialog()">{{config.confirmOkText}}</ad-button>
    </div>
</div>